
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19 4a1 1 0 011 1v9.17a3.001 3.001 0 11-2 0V5a1 1 0 011-1zm0 12a1 1 0 100 2 1 1 0 000-2zM12 4a3 3 0 00-1 5.83v9.08c0 .602.448 1.09 1 1.09s1-.488 1-1.09V9.83A3.001 3.001 0 0012 4zm-1 3a1 1 0 112 0 1 1 0 01-2 0zM5 4a1 1 0 011 1v4.17a3.001 3.001 0 010 5.66V19a1 1 0 11-2 0v-4.17a3.001 3.001 0 010-5.66V5a1 1 0 011-1zm-1 8a1 1 0 112 0 1 1 0 01-2 0z","fill":"#999"}})])
          )
        }
      }
    